import { toaster } from '~/shared/utils/toaster';

export class VolumeExclusionMissingAccountError extends Error {
  constructor() {
    super('Account context is missing for this volume.');
    this.name = 'VolumeExclusionMissingAccountError';
  }
}

export function assertVolumeExclusionAccountId(
  accountId: string | undefined,
  isOrganizationAccount: boolean
): void {
  if (isOrganizationAccount && !accountId) {
    throw new VolumeExclusionMissingAccountError();
  }
}

export function handleVolumeExclusionError(error: unknown, action: 'create' | 'remove'): void {
  if (error instanceof VolumeExclusionMissingAccountError) {
    toaster({
      variant: 'error',
      title: 'Cannot update exception',
      message: error.message,
    });
    return;
  }

  console.error(`Failed to ${action} exception:`, error);
  toaster({
    variant: 'error',
    title: 'Error',
    message: `Failed to ${action} exception. Please try again.`,
  });
}
